import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {take} from 'rxjs/operators';
import {PlatformCommand} from '@shared/commands/command-base';
import {CommandService} from '@core/services/command.service';
import {Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {DialogModel} from '@shared/models/dialog.model';
import {Injectable} from '@angular/core';
import {AuditTrackerCommandHandlerBase} from '@features/audit-tracker/services/command-handlers/audit-tracker-command-handler-base';

@Injectable({
  providedIn: 'root',
})
export class AddAuditStageCommandHandler extends AuditTrackerCommandHandlerBase implements IPlatformCommandHandler {
  constructor( public router: Router,
               private dialogService: DialogService,
               public commandService: CommandService,
               public fuseSplashScreenService: FuseSplashScreenService,
               public snackBarService: SnackBarService)  {
    super(router, commandService, fuseSplashScreenService, snackBarService);
  }
  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    const dialogModel: DialogModel = DialogModel.create(
      'Add New Stage',
      'AddAuditStageDialogComponent',
      {},
      "400px",
      "600px",
      true
    );
    this.dialogService.showOkCancelDialog(dialogModel).pipe(take(1)).subscribe(res => {
      if (res.action === 'OK') {
        console.log('OK button clicked!');
        // parse the values
        command.fieldValues['StageName'] = res.data.input['StageName'];
        this.executeCommandToApi(command, handler);
    }});
    return true;
  }

}
